import { ExpandMore as ExpandMoreIcon, WarningAmber } from 'components/icons';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from 'components/ui/collapsible';
import { SECTION_PANEL } from 'pages/invoices/layout/views/details-tab/SectionCard';
import { ReactNode } from 'react';
import { cn } from 'utils/cn';
import { WARNING_ROW_CLASS } from './WarningRow';

const LINE_CLASS = 'border-divider text-body2 rounded-lg border';
const LINE_SUMMARY_CLASS = 'flex w-full items-center gap-2 px-4 py-2 text-left';

/**
 * A one-line summary that expands to its details, opening and closing like the invoice's "Billing info"
 * section. Collapsed by default.
 */
export function CollapsibleLine({
    summary,
    children,
    isWarning = false,
}: {
    summary: ReactNode;
    children: ReactNode;
    isWarning?: boolean;
}) {
    return (
        <Collapsible className={cn(LINE_CLASS, isWarning && WARNING_ROW_CLASS)}>
            <CollapsibleTrigger
                className={cn(
                    LINE_SUMMARY_CLASS,
                    'group focus-visible:ring-ring/50 cursor-pointer outline-none focus-visible:ring-3'
                )}
            >
                {isWarning ? <WarningAmber className="text-warning size-4 shrink-0" /> : null}
                <span className="flex flex-1">{summary}</span>
                <ExpandMoreIcon className="text-grey-500 transition-transform group-data-[panel-open]:rotate-90" />
            </CollapsibleTrigger>
            <CollapsibleContent keepMounted className={SECTION_PANEL}>
                <div className="flex flex-col gap-3 px-4 pt-1 pb-3">{children}</div>
            </CollapsibleContent>
        </Collapsible>
    );
}

/** The same line for a state with nothing to expand. */
export function PlainLine({ children }: { children: ReactNode }) {
    return (
        <div className={LINE_CLASS}>
            <div className={LINE_SUMMARY_CLASS}>{children}</div>
        </div>
    );
}
